// Add your custom JS here.
jQuery(document).ready(function($) {
$(window).scroll(function() {
	if ($(this).scrollTop() > 120){  
		$('#wrapper-navbar').addClass("sticky");
	}
	else{
		$('#wrapper-navbar').removeClass("sticky");
	}
});
});

jQuery(document).ready(function($) {
	$('.phrase-slider').slick({
	dots: false,
	arrows: false,
	infinite: true,
	speed: 500,
	fade: true,
	cssEase: 'linear',
	variableWidth: false,
	adaptiveHeight: true,
	autoplay:true,
	autoplaySpeed: 3000,
	slidesToScroll: 1,
	useAutoplayToggleButton: false,
	});
});

jQuery(document).ready(function($) {
	
	$('.related-wrap').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.case-slider');
		var $next = $(sliderWrap).find('.next');
		var $prev = $(sliderWrap).find('.prev');
		
		$slider.on('init', function (event, slick) {
			if (slick.slideCount === 1) {
				$slider.find('.slick-track').addClass('single-slide');
			}
		});
		
		$slider.slick({
			dots: false,
			adaptiveHeight: false,
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			nextArrow: $next,
			prevArrow: $prev,
			responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 1,
				adaptiveHeight: false,
				slidesToScroll: 1
			  }
			},
			]
		});
	});
});


jQuery(document).ready(function ($) {
	function equalizeHeights() {
		let maxHeight = 0;
		$('.case-slider .slider-item').each(function () {
			let thisHeight = $(this).outerHeight();
			if (thisHeight > maxHeight) {
				maxHeight = thisHeight;
			}
		});
		$('.case-slider .slider-item').css('height', maxHeight + 'px');
	}

	$('.case-slider').on('setPosition', function () {
		equalizeHeights();
	});

	$(window).on('resize', function () {
		setTimeout(equalizeHeights, 300);
	});
});


//
//		COOKIE SCRIPTS
//=========================================================================

jQuery(document).ready(function($) {
// If the 'hide cookie is not set we show the message
if (!readCookie('HFalertHide')) {
$('.alertBanner').show();
}

// Add the event that closes the popup and sets the cookie that tells us to
// not show it again until one day has passed.
$('#close').click(function() {
$('.alertBanner').hide();
createCookie('HFalertHide', true, )
return false;
});

	// ---
// And some generic cookie logic
// ---
function createCookie(name,value,days) {
  if (days) {
	var date = new Date();
	date.setTime(date.getTime()+(days*24*60*60*1000));
	var expires = "; expires="+date.toGMTString();
  }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/";
}

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0;i < ca.length;i++) {
	var c = ca[i];
	while (c.charAt(0)==' ') c = c.substring(1,c.length);
	if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
  }
  return null;
}

function eraseCookie(name) {
  createCookie(name,"",-1);
}
});